import React from "react";
import "./oneonone.css";
import Image1 from "../../../Assets/Images/one-on-one-1.png";
import Image2 from "../../../Assets/Images/one-on-one-2.png";
import Image3 from "../../../Assets/Images/one-on-one-3.png";
import Image4 from "../../../Assets/Images/one-on-one-4.png";
import Image5 from "../../../Assets/Images/one-on-one-5.png";

const OneOnOneSessions = () => {
  const cards = [
    {
      title: "Personalized Attention",
      desc: "The coach or instructor can tailor the session to the individual's specific needs, strengths, and weaknesses.",
      img: Image1,
    },
    {
      title: "Customized Feedback",
      desc: "The coach or instructor can tailor the session to the individual's specific needs, strengths, and weaknesses.",
      img: Image2,
    },
    {
      title: "Flexible Pacing",
      desc: "Sessions move at a pace suitable for the individual, allowing for a more thorough understanding and mastery of skills.",
      img: Image3,
    },
    {
      title: "Confidentiality",
      desc: "Private sessions address personal issues or sensitive topics that may not be suitable in a group setting.",
      img: Image4,
    },
    {
      title: "Stronger Relationship",
      desc: "Builds a stronger mentor-mentee relationship, fostering trust and open communication.",
      img: Image5,
    },
  ];

  return (
    <div className="sessions-container">
      <h2 className="one-on-one-text black-text-clip">One on One Sessions</h2>

      <div className="sessions-grid">
        {cards.map((c, i) => (
          <div
            key={i}
            className="session-card image-card"
            style={{ backgroundImage: `url(${c.img})` }}
          >
            <div className="text-wrapper">
              <p className="card-text">{c.title}</p>
              <p className="hover-text">{c.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OneOnOneSessions;
